export default {"src":"/_next/static/media/PR.a326d6d0.svg","height":18,"width":18};